import type { ComponentType } from 'react';
import type PeopleSettingsType from '@jira/spa-apps__project-settings-people/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyPeopleSettings: LazyComponent<ComponentType<Record<any, any>>> = lazyForPaint<
	typeof PeopleSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-people", jiraSpaEntry: "async-project-settings-people" */ '@jira/spa-apps__project-settings-people/src/index.tsx'
		),
	),
);
